import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMedia } from "react-use";
import { Theme, UiLegacy } from "@silvertours/front-legacy-shared";
import { LocationName, StyledHeader } from "./Reviews.styles";
var ReviewHeader = function(param) {
    var aggregateRating = param.aggregateRating, dateLabel = param.dateLabel, ratingLabel = param.ratingLabel, locationName = param.locationName, ratingLocation = param.ratingLocation;
    var isMobile = useMedia("(max-width: ".concat(Theme.getBreakpoint("lg"), "px)"), true);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(StyledHeader, {
                children: [
                    /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                        children: dateLabel
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Rating, {
                        value: aggregateRating
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.SmallText, {
                        children: ratingLabel
                    }),
                    locationName && !isMobile && /*#__PURE__*/ _jsx(UiLegacy.SmallText, {
                        children: ratingLocation
                    })
                ]
            }),
            locationName && isMobile && /*#__PURE__*/ _jsx(UiLegacy.SmallText, {
                children: /*#__PURE__*/ _jsx(LocationName, {
                    children: ratingLocation
                })
            })
        ]
    });
};
export { ReviewHeader };
